 /*
  Author: Vaishnavi
  Date: 18/11/2019
  Issue Description: Visual Bug fixes assigned by Harshvardhan Kore & Tarun Bhandari, <upload-image /> tag added (line no. 104)
  BugId: 15368_UAT
  */
/*
  Author: Vinod
  Date: 07/01/2020
  Issue Description: from backend we are showing correct  but from frontend we are not showing correct radio button as selected.
  Issue Id: PL_2377
 */
/*
  Author: Vinod
  Date: 23/01/2020
  Issue Description: When changes made to the Payslip Preferences at PG and on clicking Save, no action being performed.
  Issue Id: PL_2480
 */

/*
  Author: Vinod
  Date: 09/04/2020
  Issue Description: spelling mistake of Cost centre.
  Issue Id: PL_3049
 */

 /*
 Author: Vinod
 Date: 20/04/2020
 Issue Description: Unable to create or edit pay groups.
 search_string: PL_3062
*/

<template>
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <!-- accordion header-->
    <tl-accordion headerName="Payslip Header" :active="true">
      <template v-slot:accordionBody>
        <!-- company logo -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <tl-checkbox
              class="headcheck"
              label="Company Logo"
              v-model="payslipModel.company_logo"
            />
          </div>
          <!-- align section -->
          <div class="col-7 padding-l-n section-details">
            <div class="row margintop-10">
              <div>
                <tl-radio
                  name="logo_align"
                  id="logoleftalign"
                  label="Left align"
                  value="left"
                  :disabled="!payslipModel.company_logo"
                  v-model="payslipModel.logo_alignment"
                />
              </div>
              <div>
                <tl-radio
                  name="logo_align"
                  id="logocentrealign"
                  label="Centre align"
                  value="centre"
                  :disabled="!payslipModel.company_logo"
                  v-model="payslipModel.logo_alignment"
                />
              </div>
              <div>
                <tl-radio
                  name="logo_align"
                  id="logorightalign"
                  label="Right align"
                  value="right"
                  :disabled="!payslipModel.company_logo"
                  v-model="payslipModel.logo_alignment"
                />
              </div>
            </div>
          </div>
          <!-- align section -->
        </div>
        <!-- company logo -->

        <!-- company name -->
        <div class="row margintop-20" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <tl-checkbox
              class="headcheck"
              label="Company Name"
              v-model="payslipModel.company_name"
            />
          </div>
          <!-- align section -->
          <div class="col-7 padding-l-n section-details">
            <div class="row">
              <div>
                <tl-radio
                  name="name_align"
                  id="leftalign"
                  label="Left align"
                  value="left"
                  :disabled="!payslipModel.company_name"
                  v-model="payslipModel.company_name_alignment"
                />
              </div>
              <div>
                <tl-radio
                  name="name_align"
                  id="center"
                  label="Centre align"
                  value="centre"
                  :disabled="!payslipModel.company_name"
                  v-model="payslipModel.company_name_alignment"
                />
              </div>
              <div>
                <tl-radio
                  name="name_align"
                  id="rightalign"
                  label="Right align"
                  value="right"
                  :disabled="!payslipModel.company_name"
                  v-model="payslipModel.company_name_alignment"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- align section -->
        <!-- company name -->

        <!-- Address -->
        <div class="row margintop-20" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="heading">Address</div>
          </div>
          <div class="col-3">
            <div class="alignClass">
              <tl-radio
                name="address"
                id="leaddress"
                label="Legal Entity Registered Address"
                value="LEGALADDR"
                v-model="company_address"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="alignClass">
              <tl-radio
                name="address"
                id="locaddress"
                label="Location Address"
                value="LOCATIONADDR"
                v-model="company_address"
              />
            </div>
          </div>
        </div>
        <!-- date format -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12 margin-t-l">
            <tl-checkbox
              name="month_year"
              class="headcheck"
              label="Month &amp; Financial Year "
              v-model="payslipModel.month_year"
            />
          </div>
          <!-- Format -->
          <div class="col-7 padding-l-n section-details">
            <div class="row">
              <div class="col-3 padding-l-n">
                <tl-radio
                  name="monthYearFormat"
                  id="fullmonth"
                  label="MMM/YYYY"
                  value="mmmyyyy"
                  v-model="payslipModel.month_year_format"
                  :disabled="!payslipModel.month_year"
                />
              </div>
              <div class="col-3">
                <tl-radio
                  name="monthYearFormat"
                  id="month"
                  label="MM/YYYY"
                  value="mmyyyy"
                  v-model="payslipModel.month_year_format"
                  :disabled="!payslipModel.month_year"
                />
              </div>
            </div>
          </div>
          <!-- Format -->
        </div>
      </template>
    </tl-accordion>

    <!-- action section -->

    <!-- accordion body-->
    <tl-accordion headerName="Payslip Body Content">
      <template v-slot:accordionBody>
        <div class="row">
          <div class="col-12">
            <div
              class="below-text"
            >Below are the selected employee fields you want to show in Payslip.</div>
          </div>
        </div>
        <!-- Employee Info -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Employee Info</div>
            <div class="twoColumnGrid new-width-twoColumnGrid">
              <tl-checkbox
                class="headcheck"
                name="employee_name"
                label="Employee Name"
                v-model="payslipModel.employee_name"
              />
              <tl-checkbox
                class="headcheck"
                name="official_mail"
                label="Official Mail ID"
                v-model="payslipModel.official_mail"
              />
              <tl-checkbox
                class="headcheck"
                name="employee_code"
                label="Employee Code "
                v-model="payslipModel.employee_code"
              />
              <tl-checkbox
                class="headcheck"
                name="personal_mail"
                label="Personal Mail ID"
                v-model="payslipModel.personal_mail"
              />
              <tl-checkbox
                class="headcheck"
                name="date_joined"
                label="Date joined"
                v-model="payslipModel.date_joined"
              />
              <tl-checkbox
                class="headcheck"
                name="dob"
                label="Date of Birth"
                v-model="payslipModel.dob"
              />
              <!-- PL_3049 -->
              <tl-checkbox
                class="headcheck"
                name="cost_centre"
                label="Cost Centre"
                v-model="payslipModel.cost_centre"
              />
              <tl-checkbox
                class="headcheck"
                name="phone_number"
                label="Phone no."
                v-model="payslipModel.phone_number"
              />
              <tl-checkbox
                class="headcheck"
                name="designation"
                label="Designation"
                v-model="payslipModel.designation"
              />
              <tl-checkbox
                class="headcheck"
                name="permanent_address"
                label="Permanent Address"
                v-model="payslipModel.permanent_address"
              />
              <tl-checkbox
                class="headcheck"
                name="total_number_of_paid_days"
                label="Total no. of paid days"
                v-model="payslipModel.total_number_of_paid_days"
              />
              <tl-checkbox
                class="headcheck"
                name="emergency_contact_number"
                label="Emergency contact no."
                v-model="payslipModel.emergency_contact_number"
              />
              <tl-checkbox
                class="headcheck"
                name="no_of_lop"
                label="No. of LOPs"
                v-model="payslipModel.no_of_lop"
              />
              <tl-checkbox
                class="headcheck"
                name="pan_number"
                label="PAN card no."
                v-model="payslipModel.pan_number"
              />
              <tl-checkbox
                class="headcheck"
                name="no_of_rlop"
                label="No. of RLOPs"
                v-model="payslipModel.no_of_rlop"
              />
              <tl-checkbox
                class="headcheck"
                name="aadhar_number"
                label="Aadhar no."
                v-model="payslipModel.aadhar_number"
              />
              <tl-checkbox
                class="headcheck"
                name="uan_number"
                label="UAN No."
                v-model="payslipModel.uan_number"
              />
            </div>
          </div>
        </div>
        <!-- User Defined Fields -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">User Defined Fields</div>
            <div
              class="twoColumnGrid new-width-twoColumnGrid margintop-24"
              v-for="(data, index) in udfData"
              :key="index"
            >
              <tl-checkbox
                class="headcheck"
                :name="'udf'+index"
                :label="`${data.name}`"
                v-model="data.show"
              />
            </div>
          </div>
        </div>
        <!-- Bank Info -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Bank Info</div>
            <div class="singleColumnGrid">
              <tl-checkbox
                class="headcheck"
                name="payment_mode"
                label="Payment Mode"
                v-model="payslipModel.payment_mode"
              />
              <tl-checkbox
                class="headcheck"
                name="bank_name"
                label="Bank Name"
                v-model="payslipModel.bank_name"
              />
              <tl-checkbox
                class="headcheck"
                name="bank_account_number"
                label="Bank Account Number"
                v-model="payslipModel.bank_account_number"
              />
              <tl-checkbox
                class="headcheck"
                name="ifsc_code"
                label="IFSC Code"
                v-model="payslipModel.ifsc_code"
              />
            </div>
          </div>
        </div>
        <!-- Format for Payslip -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Format for Payslip</div>
            <div class="row margintop-10">
              <div class="col-2" v-for="(format, index) of payslipFormatList" :key="index">
                <tl-radio
                  name="payslipFormatType"
                  :id="'payslipFormat'+index"
                  :label="format.name"
                  :value="format.id"
                  v-model="payslipModel.payslip_format_id"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Component -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Include Payslip</div>
            <div class="twoColumnGrid new-width-twoColumnGrid">
              <tl-checkbox
                class="headcheck"
                name="fbp_component"
                label="FBP components"
                v-model="payslipModel.fbp_component"
              />
              <tl-checkbox
                class="headcheck"
                name="it_sheet"
                label="IT Sheet"
                v-model="payslipModel.it_sheet"
              />
            </div>
          </div>
        </div>

        <!-- Other Info -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Other Info</div>
            <div class="singleColumnGrid">
              <tl-checkbox
                class="headcheck"
                name="loan_details"
                label="Loan Details"
                v-model="payslipModel.loan_details"
              />
              <tl-checkbox
                class="headcheck"
                name="leave_details"
                label="Leave Details"
                v-model="payslipModel.leave_details"
              />
              <tl-checkbox
                class="headcheck"
                name="leave_balances"
                label="Leave Balances"
                v-model="payslipModel.leave_balances"
              />
              <tl-checkbox
                class="headcheck"
                name="arrear_days"
                label="Arrear Days"
                v-model="payslipModel.arrear_days"
              />
              <tl-checkbox
                class="headcheck"
                name="release_fnf"
                label="Release FnF Payslips based on date of relieving"
                v-model="payslipModel.release_fnf"
              />
            </div>
          </div>
        </div>
      </template>
    </tl-accordion>

    <!-- accordion body-->
    <tl-accordion headerName="Payslip Footer">
      <template v-slot:accordionBody>
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="label-text margin-b-s">Customise Footer Message</div>
            <textarea
              class="form-control width-100"
              label="Customise Footer Message"
              name="calculation"
              v-model="payslipModel.footer_message"
            />
          </div>
        </div>
      </template>
    </tl-accordion>

    <div class="row margin-t-m" v-if="!isFromPaygroup" :disabled="!(ifTeamleaderPermission)">
      <div class="col-12 text-center">
        <button class="btn primaryBtn" type="primary" @click="createPayslip">Save and Preview</button>
      </div>
    </div>
    <!-- action section -->

    <!-- preview modal -->
    <div class="modal custom-modal" v-if="showPreviewModal">
      <div class="modal-content modal-md">
        <div class="modal-header">
          <div class="row">
            <div class="col-6">
              <h3>Payslip Preview</h3>
            </div>
            <div class="col-6 align-right">
              <a href="javascript:void(0)" class="close-btn" @click="previewPayslipCancel">Close</a>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <!-- select-section -->
          <iframe
            id="payslip"
            v-if="previewPayslipUrl"
            :src="previewPayslipUrl"
            style="width:100%; height:450px;"
            frameborder="0"
          />
          <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Close" type="secondary" @click="previewPayslipCancel" />
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
    <!-- preview modal -->
    <div class="button-group">
      <bottom-action-container>
        <!-- PL_2480 -->
        <btn-skip @navClicked="skip" v-if="!isFromPaygroup"></btn-skip>
        <template slot="end">
          <btn-grp v-if="!isFromPaygroup">
            <btn text="Previous" type="secondary" @click="$emit('stepNum',4)" />
            <btn text="Next" :disabled="!isPayslipSubmitted" type="primary" @click="skip()" v-show="!ifAnchor && ifTeamleaderPermission"/>
            <btn text="Next" type="primary" @click="nextPage" v-show="ifAnchor || !ifTeamleaderPermission"/>
          </btn-grp>
          <btn-grp v-if="isFromPaygroup">
            <btn text="Cancel" type="secondary" @click="$emit('goBackToPaygroup', {})"></btn>
            <btn text="Save" type="primary" @click="savePaygroupPayslip"></btn>
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
// import * as C from "@/src/apis/config.js"
export default {
  name: "Payslips",
  // PL_2480
  props: {
    isFromPaygroup: {
      type: Boolean,
      default: false
    },
    isCustom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPreviewModal: false,
      showAccordionBody: false,
      udfData: [],
      isCompanyLogo: false,
      showDatepicker: true,
      previewPayslipUrl: "",
      isPayslipCreated: false,
      company_address: "LEGALADDR",
      isMonthAndFinancialYear: false,
      payslipFormatList: [],
      payslipModel: {
        le_id: null,
        name: "",
        company_logo: true,
        logo_alignment: "right",
        company_name: true,
        company_name_alignment: "right",
        company_address: true,
        month_year: true,
        month_year_format: "mmmyyyy",
        employee_name: true,
        employee_code: true,
        date_joined: true,
        cost_centre: true,
        designation: true,
        total_number_of_paid_days: true,
        no_of_lop: true,
        no_of_rlop: true,
        uan_number: true,
        official_mail: true,
        personal_mail: true,
        dob: true,
        phone_number: true,
        permanent_address: true,
        emergency_contact_number: true,
        pan_number: true,
        aadhar_number: true,
        bank_name: true,
        bank_account_number: true,
        payment_mode: true,
        ifsc_code: true,
        payslip_format_id: null,
        fbp_component: true,
        it_sheet: true,
        loan_details: true,
        leave_details: true,
        leave_balances: true,
        arrear_days: true,
        release_fnf: true,
        default: true,
        udf_setting: [],
        footer_message: "",
        header_message: ""
      },
      isPayslipSubmitted: false,
      formatOptions: ["defaultSettings"],
      paygroupOptions: ["PayGroup 1", "PayGroup 2"],
      payrollPreferencesValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
      payGroupPayslipData: state => state.onboard.paygroup.record // PL_2480
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.payrollPreferencesValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.payrollPreferencesValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  mounted() {
    this.setGlobalData();
    this.getUdfData();
    this.getOrgLeIdList();
    // PL_2480
    if (
      !(this.isFromPaygroup && Object.keys(this.payGroupPayslipData).length)
    ) {
      this.getPayslipData();
    }
  },
  activated() {
    this.setGlobalData();
    this.getUdfData();
    this.getPayslipData();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      create_payslip: "onboard/settings/payslip/create",
      update_payslip: "onboard/settings/payslip/update",
      fetch_payslip: "onboard/settings/payslip/fetchAll",
      previw_payslip: "onboard/settings/payslip/payslipPreview",
      act_fetchUdf: "onboard/importUdf/fetchAll"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get UDF list for current LE */
    async getUdfData() {
      try {
        let res = await this.act_fetchUdf(this.leId);
        if (res.data.status && res.data.payload.data.length) {
          this.udfData = res.data.payload.data.map(item => {
            return { id: item.id, name: item.name, show: false };
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    //  Start PL_2480

    /* function to save(in store) pay group payslip data for custom pay group */
    savePaygroupPayslip() {
      try {
        if (this.isCustom) {
          this.payslipModel.selected_paygroup_id = null;
        }
        if (this.company_address == "LEGALADDR") {
          this.payslipModel.company_address = true;
        } else {
          this.payslipModel.company_address = false;
        }
        this.payslipModel.udf_setting = this.udfData.filter(item => {
          return item.show;
        });
        this.payslipModel.le_id = this.leId; // PL_3062
        this.$emit("goBackToPaygroup", this.payslipModel);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set payslip data from pay group for custom pay group */
    setPaygroupPayslipData() {
      try {
        this.isPayslipCreated = true;
        this.payslipModel = this.payGroupPayslipData.PayslipMapping[0].preferences; // PL_3062
        if (this.isCustom) {
          this.payslipModel.selected_paygroup_id = null;
        }
        this.payslipModel.month_year_format = this.payGroupPayslipData.PayslipMapping[0].preferences.month_year_format; // PL_3062
        if (
          this.payGroupPayslipData.PayslipMapping[0].preferences.company_address // PL_3062
        ) {
          this.company_address = "LEGALADDR"; // PL_2377
        } else {
          this.company_address = "LOCATIONADDR"; // PL_2377
        }
        this.udfData.forEach(element => {
          let isExist = this.payslipModel.udf_setting.some(
            item => item.id == element.id
          );
          if (isExist) {
            element.show = true;
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    //  End PL_2480

    /* function to set default values */
    setGlobalData() {
      try {
        this.payslipFormatList = this.globalData.PayslipFormat
          ? this.globalData.PayslipFormat
          : [];
        if (!this.isPayslipCreated) {
          this.company_address = "LEGALADDR";

          // PL-1852, 20/11/2019
          setTimeout(() => {
            // by default setting - 26/11/2019
            this.payslipModel.payslip_format_id = this.payslipFormatList[1].id;
            this.payslipModel.month_year_format = "mmmyyyy";
            if (
              this.isFromPaygroup &&
              Object.keys(this.payGroupPayslipData).length &&
              this.payGroupPayslipData.PayslipMapping[0].preferences
                .selected_paygroup_id == null // PL_3062
            ) {
              this.setPaygroupPayslipData();
            } else {
              this.getPayslipData();
            }
          }, 500);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to submit payslip form data */
    async createPayslip() {
      try {
        this.payslipModel.le_id = this.leId;
        if (this.company_address == "LEGALADDR") {
          this.payslipModel.company_address = true;
        } else {
          this.payslipModel.company_address = false;
        }
        try {
          this.payslipModel.udf_setting = this.udfData.filter(item => {
            return item.show;
          });
          let res = {};
          res = await this.create_payslip({
            data: {
              ...this.payslipModel,
              selected_paygroup_id: null
            }
          });
          if (res.data.status) {
            this.payslipModel["id"] = res.data.payload.id;
            this.isPayslipCreated = true;
            this.previewPayslip();
          }
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get payslip data */
    async getPayslipData() {
      try {
        let res = await this.fetch_payslip(this.leId);
        if (res.data.status && res.data.payload) {
          let Obj = res.data.payload;
          if (Obj) {
            this.isPayslipCreated = true;
            this.payslipModel = Obj;
            this.udfData.forEach(element => {
              let isExist = Obj.udf_setting.some(item => item.id == element.id);
              if (isExist) {
                element.show = true;
              }
            });
            this.payslipModel.month_year_format = Obj.month_year_format;
            if (Obj.company_address) {
              this.company_address = "LEGALADDR"; // PL_2377
            } else {
              this.company_address = "LOCATIONADDR"; // PL_2377
            }
          } else {
            this.isPayslipCreated = false;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to toggle accordion */
    toggleContent() {
      this.showAccordionBody = !this.showAccordionBody;
    },

    /* fuction to go to pay group page */
    skip() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      );
    },

    /* server call to get payslip format as PDF */
    async previewPayslip() {
      try {
        let res = await this.previw_payslip(this.leId);
        let myBlob = new Blob([res.data], { type: "application/pdf" });
        let myReader = new FileReader();
        myReader.onloadend = e => {
          this.previewPayslipUrl = myReader.result;
        };
        myReader.readAsDataURL(myBlob);
        if (res.status == 200) {
          this.showPreviewModal = true;
          this.isPayslipSubmitted = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to hide the preview modal */
    previewPayslipCancel() {
      this.showPreviewModal = false;
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      );
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollPreferencesValue = data.data.user.permissions.payroll_preferences ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/components/margins.scss"; //for margins
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.payslip-label {
  font-size: 16px;
  font-weight: 600;
  font-family: Montserrat;
  color: rgb(26, 25, 25);
  margin-top: 24px;
  margin-bottom: 24px;
}
.new-width-twoColumnGrid {
  grid-template-columns: 25% 25%;
}
.button-group {
  margin-left: -16px;
}
.primaryBtn {
  background-color: #5d409f;
  border: #5d409f solid 1px;
  color: #ffffff;
  display: inline-block;
}
.alignClass {
  margin-top: 10px;
}
.close-btn {
  position: relative;
  top: 15px;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
}
.heading {
  font-size: 14px;
  font-weight: bold;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
